<div class="d-flex overviews-sorting">
    @for (column of columns; track column) {
        <a class="me-3" (click)="onSort(column)">
            <span class="me-2">{{ column.displayName }}</span>
            @switch (column.orderDirection) {
                @case (null) {
                    <i class="fas fa-sort"></i>
                }
                @case (OrderDirection.asc) {
                    <i class="fas fa-sort-up"></i>
                }
                @case (OrderDirection.desc) {
                    <i class="fas fa-sort-down"></i>
                }
            }
        </a>
    }
</div>
